// extracted by mini-css-extract-plugin
export var calendarView = "_of-0";